import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { decode, encode} from 'base-64';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../src/Auth/authconfig";
import BodyProvider from "./contexts/BodyProvider";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);
const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

if (!global.btoa) {
  global.btoa = encode;
}

if (!global.atob) {
  global.atob = decode;
}

root.render(
  <Suspense
    fallback={
      <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="spinner-grow text-secondary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    }
  >
    <MsalProvider instance={msalInstance}>
      <BodyProvider>
        <App />
      </BodyProvider>
    </MsalProvider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
